import React from "react";
import HeaderName from "../../HeaderName";
import SideBar from "../../SideBar";
import Breadcrumb from "../../../common/Breadcrumb";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PurchaseVoucherList from "./PurchaseVoucherList";
import PurchaseVoucherHeader from "./PurchaseVoucherHeader";

const PurchaseVoucher = () => {
  const navigate = useNavigate();
  return (
    <div classNameName="App">
      <div className="wrapper">
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className="content-wrapper">
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <Breadcrumb currentPage="Purchase Voucher" />
                  {/* <PurchaseRequestHeader /> */}
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className="content">
            <div className="container-fluid">
              <div className="row d-flex justify-content-between">
                <div className="col-md-6">
                  {/* <h4>Medicine Item List</h4> */}
                </div>
              </div>
              <div className="row">
                <PurchaseVoucherHeader />
                <PurchaseVoucherList />
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer" style={{ marginTop: "50px;" }}>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href="http://www.kwintechnologies.com">K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
};

export default PurchaseVoucher;
